import { BrowserRouter, Route, Routes } from "react-router-dom";

import "./index.css"
import "./styles/fonts.css";
import "./styles/containers.css";

import { HomePage } from "./features/home/home-page";
import { FourOhFour } from "./features/others/not-found";
import { AboutPage } from "./features/about/about";
import { Development } from "./features/development/development";
import { MbeiVillage } from "./features/village/village";
import { MbecudaBranches } from "./features/branches/branches";
import { BlogPage } from "./features/blog/blogs";
import { MbeiAdmin } from "./features/admin/admin";

import { AuthenticationContextProvider } from "./services/authentication/authentication.context";
import { BlogPostContextProvider } from "./services/blogs/blogpost.context";
import { BlogDetails } from "./features/blog/blog-details";
import { Authentication } from "./features/admin/login";
import { Protected } from "./components/auth/protected.route";
import { BlogRedir } from "./features/blog/blog-redir";
import { UnderDev } from "./features/others/dev";
import { Restricted } from "./features/others/restricted";

function App() {
  return (
    <BrowserRouter>
      <AuthenticationContextProvider>
        <BlogPostContextProvider>
          <Routes>
            <Route path="*" element={<FourOhFour />} />
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/development" element={<Development />} />
            <Route path="/village" element={<MbeiVillage />} />
            <Route path="/branches" element={<MbecudaBranches />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blogdetail" element={<BlogDetails />} />
            <Route path="/login" element={<Authentication />} />
            <Route path="/redirect" element={ <BlogRedir /> } />
            <Route path="/auth_redirect" element={<Restricted />} />
            <Route path="/dev" element={<UnderDev />} />
            <Route element={<Protected />}>
              <Route path="/admin" element={<MbeiAdmin />} />
            </Route>
          </Routes>
        </BlogPostContextProvider>
      </AuthenticationContextProvider>
    </BrowserRouter>
  );
}

export default App;
